import * as actionTypes from '../utils/constants';

const initialState = {};
export const tenantDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_TENANT_DETAILS: {
      const newState = {
        ...state,
      };
      newState.tenantDetailsReducer = action.action;
      return newState;
    }
    default: {
      return state;
    }
  }
};

export const tenantUserStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_TENANT_USER_STATUS: {
      const newState = {
        ...state,
      };
      newState.tenantUserStatusReducer = action.action;
      return newState;
    }
    default: {
      return state;
    }
  }
};

